import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router';



function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function CustomSeparator() {

  let navigate = useNavigate();  
  
  const breadcrumbs = [
    
      <Link onClick={()=> navigate('/')} underline="hover" key="1" color="primary"  sx={{color: "#2B817B", fontSize: {xl: "15px", lg: "14px", md: "14px", sm: "14px", xs: "14px"}, fontWeight: "400"}}>
      Home
    </Link>,
    
    <Link

      underline="hover"
      key="2"
      color="primary"
      
      
      sx={{color: "#2B817B", fontSize: {xl: "15px", lg: "14px", md: "14px", sm: "14px", xs: "14px"}, fontWeight: "400"}}
    >
      AllMenu
    </Link>

  ];

  return (
    <Stack spacing={2}>

      <Breadcrumbs
      
        separator={<NavigateNextIcon  width="4.73px" height="10.56px" sx={{fontSize: {xl: "15px", lg: "14px", md: "14px", sm: "14px", xs: "14px"}}} />}
        aria-label="breadcrumb"
        color="primary"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
